// extracted by css-extract-rspack-plugin
var _1 = "UX90SuRXO3UUijQQ";
export { _1 as "mark" }
// extracted by css-extract-rspack-plugin
var _1 = "UX90SuRXO3UUijQQ";
export { _1 as "mark" }
